// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1xsdk","header":"styles__header___2asc8","main":"styles__main___Zo6WQ"};